/*
* @TagTable.vue
* @Description 基站管理组件
* @Author jsh
* @Date 2021/6/28
*/
<template>
    <div class="table-item-box _padding-l-none" style="padding: 10px;">
        <section style="height: 100%;">
            <!-- 表格 -->
            <el-table :data="bsInfos"
                      @sort-change="changeSort"
                      ref="multipleTable"
                      stripe
                      @row-click="rowHandle"
                      style="width: 100%;margin-bottom: 10px;height: calc(100% - 90px);"
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column label="基站编号" min-width="160px" :sortable="filters.sortable" prop="bs_id" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bsId" @click="editRowConfig(scope.row, scope.$index)">{{scope.row.bsId}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="序列号" min-width="100px" :sortable="filters.sortable" prop="sid" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.shortId + ' (' + scope.row.sid + ')'">{{scope.row.sid}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="安装序号" min-width="100px" :sortable="filters.sortable" prop="bs_serial" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.bsSerial">{{scope.row.bsSerial}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" min-width="100px" :sortable="filters.sortable" prop="status" :sort-orders="filters.sortOrders">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="GlobalParam.bsStatus[scope.row.status]">{{GlobalParam.bsStatus[scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="基站地址" min-width="120px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.localAddress">{{scope.row.localAddress}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="目标地址" min-width="120px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.targetAddress">{{scope.row.targetAddress}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="信道" min-width="50px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.channelNumber">{{scope.row.channelNumber}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="时隙" min-width="50px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="scope.row.timeSlot">{{scope.row.timeSlot}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="功率(dB)" min-width="100px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;" :title="GlobalParam.power1s[scope.row.sendPower1] + '+' + GlobalParam.power2s[scope.row.sendPower2]">{{GlobalParam.power1s[scope.row.sendPower1] + '+' + GlobalParam.power2s[scope.row.sendPower2]}}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--分页工具条-->
            <Pagination
                :currentPage="pagination.currentPage"
                :total="pagination.total"
                :pageSize="pagination.limit"
                @handleSizeChangeSub="handleSizeChangeSub"
                @handleCurrentChangeSub="handleCurrentChangeSub"
            />

            <!-- 新增基站 -->
            <UwbBSAddDialog   ref="uwbBSAddDialog"
                              :showSerialNumber="upload.showSerialNumber"
                              :uploadUrl="upload.saveUrl"
                              :previewTitle="upload.previewTitle"
                              :previewData="upload.previewData"
                              @research = "researchBs"
            />

          <!--查询工具条-->
          <el-col>
            <el-form :inline="true" :model="filters" ref="filters">
              <el-form-item>查询条件：</el-form-item>
              <el-form-item prop="status">
                <el-select v-model="filters.status" placeholder="请选择状态" clearable @change="researchBs">
                  <el-option v-for="(value,key) in GlobalParam.bsStatus" :key="key" :label="value" :value="key" ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="keyword">
                <el-input v-model="filters.keyword" placeholder="请输入基站编号/序号" clearable @keyup.enter.native="researchBs" :style="{width: '300px'}">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="researchBs"></i>
                </el-input>
              </el-form-item>
              <el-form-item class="fixed-item-box" style="position: absolute;top: 9px;right: 10px;z-index: 3;margin: 0;">
                <el-dropdown split-button type="primary"  @click="add" trigger="click" size="mini">
                  <i class="el-icon-circle-plus-outline"></i> 新增基站
                  <el-dropdown-menu slot="dropdown" trigger="click">
                    <el-dropdown-item  icon="el-icon-delete" @click.native="deleteRows">批量删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-col>

        </section>
    </div>

</template>

<script>
    // 公共参数
	import GlobalParam from '@/global/global-param'
    // 基站组件
    import ApiOam from '@/request/api-oam'
    // 弹框组件
    import UwbBSAddDialog from './UwbBSAddDialog'
    // 分页组件
    import Pagination from '@/components/Pagination.vue'

    export default {
        name: "UwbBSTable",
        /**
         * @Des 组件引用
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        components: {
            // 标签弹出层组件
            UwbBSAddDialog,
            // 分页工具
            Pagination,
        },
        /**
         * @Des 数据定义
         * @Auth jsh
         * @Date 09:41 2021/6/28
         */
        data() {
            return {
                // 公共参数
                GlobalParam: GlobalParam,
                /**
                 * @Des 查询条件属性
                 * @Auth jsh
                 * @Date 09:41 2021/6/28
                 */
                filters: {
                    keyword: '',
                    status: '',
                    orderBy: {
                        "sid": "asc"
                    },
                    sortOrders: [
                        "ascending",
                        "descending"
                    ],
                    sortable: 'custom',
                },
                // 基站集合
                bsInfos:[],
                exportDatas:[],
                projectInfos: {},
                areas: {},
                maps: {},
                locked: false,
                speeds: ['110K', '850K', '6.81M'],
                channelNumbers: [2,5],
                groupTypes: ['零维','一维','二维','三维'],
                /**
                 * @Des 分页数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                pagination:{
                    total: 0,
                    startNum: 0,
                    limit: 50,
                    currentPage: 1
                },
                /**
                 * @Des 上传属性
                 * @Auth Zhangbin
                 * @Date 17:17 2021/4/30
                 */
                upload:{
                    previewTitle: [],
                    previewData: [],
                    saveUrl: '' ,
                    showSerialNumber: true
                },
                /**
                 * 样式修改
                 * */
                surroundSpan(value) {
                    return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
                },
            }
        },
        computed: {
        },
        created(){

        },
        mounted(){
            // 查询基站
            this.searchBs();
        },
        /**
         * @Des 方法定义
         * @Auth jsh
         * @Date 09:42 2021/6/28
         */
        methods: {
            /**
             * @Des 查询基站
             * @Auth jsh
             * @Date 09:42 2021/6/28
             */
            searchBs() {
                this.$request.postJsonRequest(ApiOam.Search_Uwb_Bs_Uri, {
                    projectId: this.$store.state.currentProjectId,
                    keyword: this.filters.keyword,
                    status: this.filters.status,
                    mapId: this.filters.mapId,
                    orderBy: this.filters.orderBy,
                    total: this.pagination.total,
                    startNum: this.pagination.startNum,
                    limit: this.pagination.limit,
                }).then(result => {
                    // console.log(result)
                    this.bsInfos = [];
                    this.pagination.total = result.total;
                    if(result.total > 0){
                        result.rows.forEach((row, index) => {
                            if(this.projectInfos.hasOwnProperty(row.projectId)){
                                row.projectName = this.projectInfos[row.projectId].projectName;
                                row.hasArea = this.projectInfos[row.projectId].hasArea;
                            }
                            // 区域名
                            row.areaName = "";
                            if(row.areaId != undefined && row.areaId != ''){
                                if(this.areas.hasOwnProperty(row.areaId)){
                                    row.areaName = this.areas[row.areaId].areaName;
                                }
                            }
                            // console.log(row.areaId, row.areaName);

                            // 地图
                            row.mapIdArray = [];
                            row.mapNameArray = [];
                            for(let key in row.mapInfoMap){
                                row.mapIdArray.push(key);
                                row.mapNameArray.push(row.mapInfoMap[key].mapName);
                            }
                            row.mapIds = row.mapIdArray.join(",");
                            row.mapNames = row.mapNameArray.join(",");
                            // console.log(row.mapIds, row.mapNames);

                            // 基站组
                            row.groupIdArray = [];
                            row.groupNameArray = [];
                            for(let key in row.bsGroupMap){
                                row.groupIdArray.push(key);
                                row.groupNameArray.push(row.bsGroupMap[key].groupName);
                            }
                            row.groupIds = row.groupIdArray.join(",");
                            row.groupNames = row.groupNameArray.join(",");
                            // console.log(row.groupIds, row.groupNames);

                            this.bsInfos.push(row);
                        });
                    }
                    // console.log(this.bsInfos)
                }).catch(error => {
                    console.error('查询基站异常', ApiOam.Search_Uwb_Bs_Uri, error);
                })
            },
            /**
             * 是否选择
             * */
            checkSelectable(row){
                return true;
            },
            /**
             * 重新搜索
             * */
            researchBs(){
                this.pagination.total = 0;
                this.pagination.startNum = 0;
                this.pagination.currentPage = 1;
                this.searchBs();
            },
            /**
             * 改变排序
             * */
            changeSort(data){
                let prop = data.prop;
                let order = data.order;
                if(order == null){
                    order = this.filters.orderBy[prop];
                }else{
                    order = order.replace("ending", "");
                }
                if(order == null){
                    this.filters.orderBy["sid"] = "asc";
                }else{
                    this.filters.orderBy = {};
                    this.filters.orderBy[prop] = order;
                }
                this.researchBs();
            },

            /**
             * @Des 当前页数据改变
             * @Auth
             * @Date 2021/6/4
             */
            handleCurrentChangeSub(val){
                this.pagination.currentPage = val;
                this.pagination.startNum = this.pagination.limit * (val-1);
                this.searchBs();
            },
            /**
             * @Des 页长度改变
             * @Auth
             * @Date 2021/6/4
             */
            handleSizeChangeSub(val){
                this.pagination.limit = val;
                this.pagination.currentPage = 1;
                this.pagination.startNum = 0;
                this.searchBs();
            },

            /**
             * 添加基站
             */
            add(){
                this.$request.postJsonRequest(ApiOam.Find_Uwb_UnAdd_Bs_Uri, {
                    orderBy: {
                        status: "asc",
                        sid: "asc"
                    }
                }).then(result => {
                    this.upload.previewTitle = [];
                    this.upload.previewData = [];
                    if(result.data.length == 0){
                        this.$message({
                            message: '未找到新增的基站',
                            type: 'info',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return;
                    }
                    if(result.code == 0 && result.data){
                        this.upload.showSerialNumber = true;
                        this.upload.saveUrl = ApiOam.Add_Uwb_Bs_Uri;
                        // 显示基站列表信息
                        this.upload.previewTitle.push({
                            label: '基站编号',
                            prop: 'bsId',
                        });
                        this.upload.previewTitle.push({
                            label: '序列号',
                            prop: 'sid',
                        });
                        this.upload.previewTitle.push({
                            label: '基站地址',
                            prop: 'localAddress',
                        });
                        this.upload.previewTitle.push({
                            label: '目标地址',
                            prop: 'targetAddress',
                        });
                        this.upload.previewTitle.push({
                            label: '信道',
                            prop: 'channelNumber',
                        });
                        this.upload.previewTitle.push({
                            label: '时隙',
                            prop: 'timeSlot',
                        });
                        this.upload.previewTitle.push({
                            label: '状态',
                            prop: 'statusName',
                        });
                        result.data.forEach((row, index) => {
                            let _row = {
                                id: row.sid,
                                bsId: row.bsId,
                                sid: row.sid,
                                localAddress: row.localAddress,
                                targetAddress: row.targetAddress,
                                channelNumber: row.channelNumber,
                                timeSlot: row.timeSlot,
                                status: row.status,
                                statusName: GlobalParam.bsStatus[row.status],
                                disabled: false,
                                checked: false,
                            }
                            let _row_ = {};
                            for (let i in _row) {
                                // 外围添加 span
                                _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                            };

                            this.upload.previewData.push(Object.assign({}, _row, _row_));
                        })
                        //弹出预览
                        this.$refs.uwbBSAddDialog.openDialog("添加基站", "确定添加");
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('查询未加入的基站异常', ApiOam.Find_Uwb_UnAdd_Bs_Uri, error);
                })
            },
            /**
             * 删除行
             * @param row
             */
            deleteRow(row){
                this.$confirm(
                    '确认删除基站：'+ row.bsId + '（' + row.sid + '）吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    let param = {
                        sids: [row.sid]
                    };
                    this.delete(param);
                });
            },
            /**
             * 删除多行
             * @param row
             */
            deleteRows(){
                let selection = this.$refs.multipleTable.selection;
                if(selection.length == 0){
                    this.$message({
                        message: '请选择要删除的数据',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量删除选中的信息吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    let sids = [];
                    selection.forEach((row, index) => {
                        sids.push(row.sid);
                    })
                    let param = {
                        sids: sids
                    };
                    this.delete(param);
                });

            },
            delete(param){
                if(this.locked) return;
                this.locked = true;
                this.$request.postJsonRequest(ApiOam.Delete_Uwb_Bs_Uri, param).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.locked = false;
                    this.researchBs();
                }).catch(error => {
                	this.locked = false;
                	console.error('删除基站异常', ApiOam.Delete_Uwb_Bs_Uri, error);
                })
            },
            /**
             * 修改坐标
             * @param row
             */
            editRowPoint(row, index){
                this.$refs.uwbBSConfigDialog.openDialog(row, index, 2);
            },
            /**
             * 修改基站配置
             */
            editRowConfig(row, index){
                // console.log(row, index);
                this.$refs.uwbBSConfigDialog.openDialog(row, index);
            },
            /**
             * 设置基站配置
             */
            setRow(row, index){
                // console.log(row, index);
                this.$nextTick(() => {
                    this.$set(this.bsInfos, index, row);
                })
            },
            readBsConfig(){
                this.$emit("readBsConfig");
            },
            /**
             * 处理行
             * @param row
             */
            rowHandle(row){
                if(row.checked){
                    row.checked = false;
                }else{
                    row.checked = true;
                }
                this.$refs.multipleTable.toggleRowSelection(row, row.checked)
            },
        },


    }
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSTable.vue